import React from 'react';
import withIcon from '../utilities/withIcon';

const IconShareAndroid = () => {
  return (
    <g>
      <path d="m12.65 9.3564a3.2646 3.2646 0 0 0 -2.5011 1.18l-3.6189-1.7537a3.0256 3.0256 0 0 0 .0181-1.5073l3.629-1.7778a3.268 3.268 0 1 0 -.8121-2.1392 3.2482 3.2482 0 0 0 .1133.8107l-3.5975 1.7623a3.2852 3.2852 0 1 0 -.0389 4.1843l3.6235 1.7565a3.2556 3.2556 0 0 0 -.1.7694 3.2852 3.2852 0 1 0 3.2846-3.2852zm0-7.7832a1.7852 1.7852 0 1 1 -1.785 1.7852 1.7871 1.7871 0 0 1 1.785-1.7852zm-9.311 8.2119a1.7871 1.7871 0 0 1 -1.7852-1.7851 1.7618 1.7618 0 0 1 .2087-.82l.0018-.0027v-.0004a1.7816 1.7816 0 1 1 1.5747 2.6082zm9.311 4.6417a1.7871 1.7871 0 0 1 -1.7852-1.7852 1.7618 1.7618 0 0 1 .2087-.82l.0018-.0027v-.0008a1.7816 1.7816 0 1 1 1.5747 2.6087z" />
    </g>
  );
};

export default withIcon(IconShareAndroid);
